import { makeUseAxios, Options } from 'axios-hooks';
import { AxiosInstance } from '../utils/api';

export type UseAxioConfig = Options;
export default makeUseAxios({ axios: AxiosInstance });
